module.exports = __webpack_public_path__ + "static/cad-designs8-e5c8bc6360f91e39806e3af648426066.png";